import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncAdminMoreStats({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/moreStats"));
  console.log("Loading", AsyncAdminMoreStats.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncAdminMoreStats;
